import { render } from "./SwitchButton.vue?vue&type=template&id=5adb3273&scoped=true"
import script from "./SwitchButton.vue?vue&type=script&lang=js"
export * from "./SwitchButton.vue?vue&type=script&lang=js"

import "./SwitchButton.vue?vue&type=style&index=0&id=5adb3273&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.2.2_vue@3.2.13_webpack@5.88.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5adb3273"]])

export default __exports__